export class APIException
{

    constructor (public errorMessage: string)
    {
    }
}